import AOS from "../node_modules/aos/dist/aos.js";

AOS.init({
  once: true,
  duration: 1000
});
